<template>
  <div>
    <!-- 漂浮的card -->
    <div class="card">
      <div class="lis1">
        <div class="text" @click="to_index()">
          首&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;页
        </div>
      </div>
      <div class="lis2">
        <div class="text1"><a href="#fengxian">证券投资</a></div>
        <div class="text2"><a href="#fengxian">风险提示</a></div>
      </div>
      <div class="lis2">
        <div class="text1"><a href="#zhishi">证券投资</a></div>
        <div class="text2"><a href="#zhishi">基础知识</a></div>
      </div>
      <div class="lis2">
        <div class="text1"><a href="#wenhua">抑制不良</a></div>
        <div class="text2"><a href="#wenhua">证券投资文化</a></div>
      </div>
      <div class="lis2">
        <div class="text1"><a href="#yewu">证券投资</a></div>
        <div class="text2"><a href="#yewu">咨询业务</a></div>
      </div>
      <div class="lis2">
        <div class="text1"><a href="#anli">证券典型</a></div>
        <div class="text2"><a href="#anli">违法案例</a></div>
      </div>
    </div>
    <div class="h1">
      <div class="h1-1">
        <div class="w">
          <div class="li-1">
            <div class="text"><a href="#fengxian">证券投资风险提示</a></div>
          </div>
          <div class="li-2"><a href="#zhishi">证券投资基础知识</a></div>
          <div class="li-3"></div>
          <div class="li-2"><a href="#wenhua">抑制不良证券投资文化</a></div>
          <div class="li-3"></div>
          <div class="li-2"><a href="#yewu">证券投资咨询业务</a></div>
          <div class="li-3"></div>
          <div class="li-2"><a href="#anli">证券典型违法案例</a></div>
        </div>
      </div>
    </div>
    <div class="h2" id="fengxian">
      <div class="w">
        <div class="li-1">
          <img src="../assets/img/banner1/h2-1.png" alt="" />
        </div>
        <div class="li-2">
          <div class="p1">
            当投资者投资证券市场的时候，可能获得较高的投资收益，但同时也存在着较大的投资风险。
          </div>
          <div class="p2">
            当投资者进行证券投资时，请选择合法的证券咨询公司，有关合法证券咨询公司和证券从业人员的信息可在中国证券业协会网站（www.sac.net.cn）查询。市场行情不可能只涨不跌，高投资收益的同时必然伴随着高投资风险，投资者应当在开户前对自身的经济承受能力和心理承受能力做出客观判断，对于自己投资证券市场的资金数额和资金来源作出谨慎决定，我们倡导闲钱投资，严禁使用养老钱、看病钱、子女教育资金甚至是自住房屋抵押贷款或其他借款投资股市。时刻牢记“股市有风险，入市需谨慎”“投资股市，买者自负”。
          </div>
        </div>
        <div class="li-3">
          <img src="../assets/img/banner1/h2-2.png" alt="" />
          <div class="text">投资者从事证券投资包括但不限于如下风险</div>
        </div>
        <div class="li-4">
          <el-scrollbar style="width: 1200px; height: 100%">
            <div class="boxx">
              <h5>1、宏观经济风险</h5>
              <p>
                国家宏观经济形势的变化以及国际经济环境和其他证券市场的变化，可能引起国内证券市场的波动，使投资者存在亏损的可能，投资者将承担由此可能造成的损失。
              </p>
              <h5>2、政策风险</h5>
              <p>
                有关证券市场的法律、法规，和相关政策、规则发生变化，可能引起证券市场价格波动，使投资者存在亏损的可能，投资者将承担由此可能造成的损失。
              </p>
              <h5>3、上市公司经营风险</h5>
              <p>
                由于上市公司所处行业整体经营形势的变化和上市公司经营管理等方面的因素，如经营决策的重大失误、高级管理人员的变更、重大诉讼等都有可能引起该公司证券价格的波动；由于上市公司经营不善甚至会导致该公司证券中止交易、暂停上市或终止上市，投资者将承担由此可能造成的损失。
              </p>
              <h5>4、技术风险</h5>
              <p>
                因交易撮合及行情揭示是通过电子通讯技术实现的，这些技术存在着被网络黑客和计算机病毒攻击的可能，由此可能给投资者带来损失。
              </p>
              <h5>5、不可抗力因素导致的风险</h5>
              <p>
                诸如地震、火灾、水灾、战争等不可抗力因素可能导致证券交易系统瘫痪；证券经营机构无法控制和不可预测的系统故障、设备故障、通讯故障、电力故障等也可能导致证券交易系统非正常运行甚至瘫痪，这些都会使投资者的交易委托无法正常进行，投资者将承担由此可能造成的损失。
              </p>
              <h5>6、特殊证券品种的风险</h5>
              <p>
                投资者应当根据自身的经济实力、承受能力和对投资品种的了解程度认真决定证券投资策略，当投资者有意投资ST、*ST类股票或者其他有较大潜在风险的证券品种(如权证等衍生品）时，尤其应当清醒地认识到该类证券品种可能蕴含着更大的风险。
              </p>
              <h5>7、其他风险</h5>
              <p>
                由于投资者的密码丢失、或投资者的身份可能被仿冒、操作不当、决策失误等原因可能导致亏损，损失将由投资者自行承担;他人给予投资者的任何保证获利或不会发生亏损的承诺都是没有法律根据的，类似的承诺不会减少发生亏损的可能。
              </p>
              <p>
                由此可见，证券市场是一个风险无时不在的市场，投资者在参与各种证券交易前务必对此有清醒的认识，建议投资者应当充分深入地了解证券市场蕴含的各项风险并谨慎行事，并认真考虑是否进行证券交易。
              </p>
            </div>
          </el-scrollbar>
        </div>
        <div class="li-5" id="zhishi">
          <img src="../assets/img/banner1/h2-3.png" alt="" />
        </div>
      </div>
    </div>
    <div class="h3">
      <div class="w">
        <div class="li-1">
          <img src="../assets/img/banner1/h2-2.png" alt="" />
          <div class="text">投资者从事证券投资包括但不限于如下风险</div>
        </div>
        <div class="li-2">
          <div class="left">
            <div class="www">
              <div class="lis1">
                <div class="p1">
                  <span>沪市</span
                  >：开盘集合竞价时间为每个交易日(下同)的9:15至9:25，连续竞价时间为：9:30至
                  11:30、13:00至15:00
                </div>
                <div class="p2">
                  <span>深市：</span
                  >开盘集合竞价时间为每个交易日(下同)的9:15至9:25；连续竞价时间为：9:30至11:30、13:00至14:57——收盘集合竞价时间为14:57至15:00
                </div>
              </div>
            </div>
            <div class="lis2">
              <div class="p1">
                股票竞价交易应以100股的整数倍进行申报，交易单笔申报最大数量不得超过100万股
              </div>
            </div>
            <div class="lis3">
              <div class="p1">(一)可实现最大成交量；</div>
              <div class="p2">
                (二)高于该价格的买入申报与低于该价格的卖出申报全部成交；
              </div>
              <div class="p3">
                (三)与该价格相同的买方或卖方至少有一方全部成交；
              </div>
            </div>
            <div class="lis4">
              <div class="p1">
                <span>深市：</span
                >深交所接受交易申报的时间为每个交易日9:159:25、9:30至11:30
                13:00至15:00。每个交易日9:20至9:25，交易主机只接受申报，但不对买卖申报或撤销申报作处理
              </div>
              <div class="p2">
                <span>沪市：</span
                >上交所接受交易申报的时间为每个交易日9:15至9:25、9:30至11:30
                13:00至15:00。每个交易日9:25至9:30，交易主机只接受申报，但不对买卖申报或撤销申报作处理
              </div>
            </div>
            <div class="lis5">
              <div class="p1">
                A股：T+1交收——T日买入的股票，自T+1日起才能卖出，T日卖出股票所得资金，自
                T+1日起才能转出至银行卡
              </div>
            </div>
            <div class="lis6">
              <div class="p1">
                (一)最高买入申报与最低卖出申报价格相同，以该价格为成交价
              </div>
              <div class="p2">
                (二)买入申报价格高于集中申报簿当时最低卖出申报价格时，以集中申报簿当时的最低卖出申报价格为成交价
              </div>
              <div class="p3">
                (三)卖出申报价格低于集中申报簿当时最高买入申报价格时，以集中申报簿当时的最高买入申报价格为成交价
              </div>
            </div>
          </div>
          <div class="right">
            <div class="wwww">
              <div class="lis1">
                <div class="p1">
                  <span>沪市：</span
                  >不接受撤单申报时间——每个交易日9:20至9:25、14:57至15:00，不接受参与竞价交易的撤销申报；在其他接受申报的时间内，未成交申报可以撤销。每个交易日9:25至9:30，交易主机只接受申报，但不对买卖申报或撤销申报作处理
                </div>
                <div class="p2">
                  <span>深市：</span
                  >每个交易日9:20至9:25的开盘集合竞价阶段，本所交易主机不接受撤单申报；其他接受交易申报的时间内，未成交申报可以撤销。每个交易日9:25至9:30，交易主机只接受申报，但不对买卖申报或撤销申报作处理
                </div>
              </div>
            </div>
            <div class="lis2">
              <div class="p1">
                股票交易实行价格涨跌幅限制，涨跌幅限制比例为10%，ST和*ST等被实施特别处理的股票价格涨跌幅限制比例为5%
              </div>
              <div class="p2">
                涨跌幅限制价格的计算公式为：涨跌幅限制价格=前收盘价×(1±涨跌幅限制比例)
              </div>
            </div>
            <div class="lis3">
              <div class="p1">限价申报和市价申报</div>
            </div>
            <div class="lis4">
              <div class="p1">
                A股交易的申报价格最小变动单位为0.01元人民币，深B股交易的申报价格最小变动单位为0.01港币，沪B股交易的申报价格最小变动单位为0.001美元
              </div>
            </div>
            <div class="lis5">
              <div class="p1">
                证券竞价交易按价格优先、时间优先的原则撮合成交价格优先的原则为：较高价格买入申报优先于较低价格买入申报，较低价格卖出申报优先于较高价格卖出申报。时间优先的原则为：买卖方向、价格相同的，先申报者优先于后申报者。先后顺序按交易主机接受申报的时间确定
              </div>
            </div>
            <div class="lis6"></div>
          </div>
        </div>
        <div class="li-3" id="wenhua">
          <img src="../assets/img/banner1/h3-13.png" alt="" />
        </div>
      </div>
    </div>
    <div class="h4">
      <div class="w">
        <div class="boxx"></div>
        <div class="li-1">
          <img src="../assets/img/banner1/h4-1.png" alt="" />
          <div class="text">
            表现为小盘股比大盘股溢价高出很多。比如印度等市场，小盘股相比大盘股却有60%左右的折价，日本、美国等市场的小盘股尽管有溢价，但远不如A股那么高。中小盘股虽然成长性较好，但其市场规模偏小，抗风险能力不足，在业绩和成长性均难以支持高股价的情况下，市场风险依然不小。而且由于近两年创业板和中小板发行了大量的新股，解禁压力突出，会对二级市场形成冲击。
          </div>
        </div>
        <div class="li-1">
          <div class="text">
            在新股上市首日进行买入交易，并择时卖出，从中赚取收益。由于新股上市首日交易无涨跌幅限制，新股被爆炒的情况曾屡见不鲜。有数据显示，超过半数的投资者在“炒新”中亏损且“炒新”者多为初次尝试上市首日买入新股。“炒新”并非是包赚不赔，其中蕴含着巨大的投资风险。因此，建议投资者在新股上市首日切勿盲目跟风买入，在参与“炒新”之前，一定要保持谨慎冷静的心态。
          </div>
          <img src="../assets/img/banner1/h4-2.png" alt="" />
        </div>
        <div class="li-1">
          <img src="../assets/img/banner1/h4-3.png" alt="" />
          <div class="text">
            表现为绩差股受到追捧炒作，一些绩差股上市公司的净资产已经为负数，丧失了其投资价值，但市场上炒作重组题材的现象依然严重。长期以来，一些中小投资者盲目听“消息”、炒“题材股”、炒“垃圾股”，希望赚快钱、赚大钱,争先恐后地加入对各种“概念”的追涨杀跌队伍中，而忽视了这背后巨大风险。
          </div>
        </div>
        <div class="li-1">
          <div class="text">
            2016年，针对市场存在的壳资源炒作、壳公司股价扭曲、市场功能的正常发挥受限等问题，证监会修订了《上市公司重大资产重组管理办法》，严格了重组上市（俗称借壳）认定标准，加大了对交易各方的市场约束，比如重组上市项目不允许配套融资，相关股东锁定期更长等。实践证明，办法的修订行之有效，避免了炒壳等破坏性行为对市场的伤害，促进了市场估值体系理性回归。
          </div>
          <img src="../assets/img/banner1/h4-4.png" alt="" />
        </div>
        <div class="li-1">
          <img src="../assets/img/banner1/h4-5.png" alt="" />
          <div class="text">
            是指在证券市场中，投资者完全不管投资的真实价值而以高价位买进股票，等行情上涨到有利可图时迅速卖出，寄希望于接下来还会有更“傻”的人以更高的价格接手的市场心理和行为。脱离上市公司基本面的新股炒作，无论其股价短期内如何暴涨，始终要受到其内在价值的约束，最终回归理性估值，一些股票上市首日爆炒及随后的大幅下跌都验证了这一点。投资者应综合参考专业机构对新股上市交易的估值定价分析，才能对股票的合理定价范围有清醒认识，减少新股上市首日交易的盲目性，远离“博傻”式的跟风炒作。
          </div>
        </div>
        <div class="li-6">
          参考资料：中国证监会《毋忘前车之鉴，警惕“炒新”风险》、2017年3月24日证监会新闻发布会
        </div>
      </div>
    </div>
    <div class="h5">
      <div class="w">
        <div class="li-1" id="yewu">
          <img src="../assets/img/banner1/h5-1.png" alt="" />
        </div>
        <div class="li-2" style="margin-bottom: 20px">
          本办法所称证券、期货投资咨询，是指从事证券、期货投资咨询业务的机构及其投资咨询人员以下列形式为证券、期货投资人或者客户提供证券、期货投资分析和预测或者
          建议等直接或者间接有偿咨询服务的活动：
        </div>
        <div class="li-3">
          <div class="text">
            （一）接受投资人或者客户委托，提供证券、期货投资咨询服务；
          </div>
          <div class="text">
            （二）举办有关证券、期货投资咨询的讲座、报告会、分析会等；
          </div>
          <div class="text">
            （三）在报刊上发表证券、期货投资咨询的文章、评论、报告，以及通过电台、电视台等公众传播媒体提供证券、期货投资咨询服务；
          </div>
          <div class="text">
            （四）通过电话、传真、电脑网络等电信设备系统，提供证券、期货投资咨询服务；
          </div>
          <div class="text">
            （五）中国证券监督管理委员会（以下简称中国证监会）认定的其他形式。
          </div>
        </div>
        <div class="li-4">
          <img src="../assets/img/banner1/h2-2.png" alt="" />
          <div class="text">相关法律法规</div>
        </div>

        <div class="li-5">
          <el-scrollbar style="width: 1200px; height: 100%">
            <div class="boxx">
              <h5>第十二条 </h5>
              <p>
                从事证券、期货投资咨询业务的人员，必须取得证券、期货投资咨询从业资格并加入一家有从业资格的证券、期货投资咨询机构后，方可从事证券、期货投资咨询业务。任何人未取得证券、期货投资咨询从业资格的，或者取得证券、期货投资咨询从业资格，但是未在证券、期货投资咨询机构工作的，不得从事证券、期货投资咨询业务。
              </p>
              <h5>第十九条</h5>
              <p>
                证券、期货投资咨询机构及其投资咨询人员，应当以行业公认的谨慎、诚实和勤勉尽责的态度，为投资人或者客户提供证券、期货投资咨询服务。
              </p>
              <h5>第二十条</h5>
              <p>
                证券、期货投资咨询机构及其投资咨询人员，应当完整、客观、准确地运用有关信息、资料向投资人或者客户提供投资分析、预测和建议，不得断章取义地引用或者篡改有关信息、资料；引用有关信息、资料时，应当注明出处和著作权人。
              </p>
              <h5>第二十一条</h5>
              <p>
                证券、期货投资咨询机构及其投资咨询人员，不得以虚假信息、市场传言或者内幕信息为依据向投资人或者客户提供投资分析、预测或建议。
              </p>
              <h5>第二十二条</h5>
              <p>
                证券、期货投资咨询人员在报刊、电台、电视台或者其他传播媒体上发表投资咨询文章、报告或者意见时，必须注明所在证券、期货投资咨询机构的名称和个人真实姓名，并对投资风险作充分说明。证券、期货投资咨询机构向投资人或者客户提供的证券、期货投资咨询传真件必须注明机构名称、地址、联系电话和联系人姓名。
              </p>
              <h5>第二十四条</h5>
              <p>证券、期货投资咨询机构及其投资咨询人员，不得从事下列活动：</p>
              <p>（一）代理投资人从事证券、期货买卖；</p>
              <p>（二）向投资人承诺证券、期货投资收益；</p>
              <p>（三）与投资人约定分享投资收益或者分担投资损失；</p>
              <p>（四）为自己买卖股票及具有股票性质、功能的证券以及期货；</p>
              <p>（五）利用咨询服务与他人合谋操纵市场或者进行内幕交易；</p>
              <p>（六）法律、法规、规章所禁止的其他证券、期货欺诈行为。</p>
              <h5>第二十五条</h5>
              <p>
                证券、期货投资咨询机构就同一问题向不同客户提供的投资分析、预测或者建议应当一致。具有自营业务的证券经营机构在从事超出本机构范围的证券投资咨询业务时，就同一问题向社会公众和其自营部门提供的咨询意见应当一致，不得为自营业务获利的需要误导社会公众。
              </p>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <div class="h6" id="anli">
      <div class="w">
        <div class="li-1">
          <img src="../assets/img/banner1/h6-3.png" alt="" />
        </div>
        <div class="li-2">
          <div class="lis1">
            <div v-for="(item, index) in btns" :key="index">
              <div
                :class="actives == index ? 'btn2' : 'btn1'"
                @click="changebar(index)"
              >
                <div class="text">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="lis2">
            <div
              @click="to_waibu(item.to)"
              class="hezi"
              v-for="(item, index) in textsss"
              :key="index"
            >
              <div v-if="actives == index">
                <div class="textss">
                  <div
                    class="p"
                    v-for="(p_item, p_index) in item.p1"
                    :key="p_index"
                  >
                    <p v-html="p_item"></p>
                  </div>
                </div>
                <div class="hrefs">
                  <span>
                    {{ item.hrefs }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "index",
  components: {},
  data() {
    return {
      actives: 0,
      btns: [
        {
          name: "案例1",
        },
        {
          name: "案例2",
        },
        {
          name: "案例3",
        },
        {
          name: "案例4",
        },
      ],
      textsss: [
        {
          p1: [
            "<p>王某被北京某投资管理集团有限公司解聘后，于2016年2月至2016年9月间，多次在北京市石景山区某小学保安室等地，虚构自己理财公司业务员身份，通过签订虚假的出借咨询与服务协议，欺骗郭某向其个人账户打款，共计骗取投资理财款34万元人民币，期间以返利等形式返还郭某5.2万元。</p>",
            "<p>北京市石景山区人民法院认为王某以非法占有为目的，在签订、履行合同过程中，骗取他人财务，数额巨大，构成合同诈骗罪，最终按照《中华人民共和国刑法》第二百二十四条有关规定，判处王某有期徒刑四年三个月，退赔被害人郭某二十八万余元，并处以五千元罚金。</p>",
            "<p>我国《证券法》第一百二十二条规定:<span style=' color: #ba0014;font-weight: 600;'>“未经国务院证券监督管理机构批准，任何单位和个人不得经营证券业务。”</span>而上述两个案例中,不法分子通过编造、虚构所谓的专业投资顾问资质，利用高额收益骗取投资者信任，进而通过虚假交易骗取投资者的财产。因此投资者在投资咨询过程中—定要时刻保持警惕，提高风险防范意识。</p>",
          ],
          hrefs: "摘自：中国证券监督管理委员会",
          to: "http://www.csrc.gov.cn/csrc/c100211/c1452036/content.shtml",
        },
        {
          p1: [
            "<p>2013年，A公司股票连续三天大幅上涨，涨跌幅偏离值累计超过12%，于是进行停牌核查。停牌后，公司披露确有筹划重大事项，但由于该项目处于论证咨询阶段，存在重大不确定性，而且预计难以保密，公司股票要继续停牌。一周后，公司股票申请复牌了，复牌同时董事会审议通过了与非公开发行相关的若干议案，其中一项议案是同意A公司与另外两方签署增资扩股框架协议。非公开发行可行性报告显示，公司与某两方签订了增资框架协议，协议主体、签订时间、增资金额等都说的有模有样。此消息一出，股价应声而涨，投资者觉得公司要增资扩股，引入战略投资者，体现战略投资者对公司价值的认可，多好的事啊，果断买入。</p>",
            "<p>谁知这份增资框架协议随后被证监会查出，根本就是子虚乌有的事情。A公司与某两方根本就没签过增资扩股框架协议，这份利好协议是上市公司凭空捏造出来的。消息证明是假的了，可投资者买入的股票是真的，还在高位套着呢。<span style=' color: #ba0014;font-weight: 600;'>A公司因为披露虚假信息，被证监会给予警告，并处以30万元罚款。</span></p>",
            "<p>投资者不能盲目相信从业人员违法承诺，应保持理性投资理念，努力提高自身专业知识与经验，才能有效地防范风险、获取投资收益。</p>",
          ],
          hrefs: "摘自：中国证券监督管理委员会",
          to: "http://www.csrc.gov.cn/csrc/c100211/c1452039/content.shtml",
        },
        {
          p1: [
            "<p>任某某长期从事大宗交易活动，经营模式是通过大宗交易方式打折买入上市公司股东减持的股票，并迅速在二级市场抛售变现，赚取差价。为了实现在二级市场高价出货，任某某屡屡在减持前一日尾市阶段拉抬收盘价，次日高价减持。以他于2011年11月23日至24日操纵的“X”为例: </p>",
            "<p>2011年11月23日， 任某某通过大宗交易买入“X”45万股，成交价格28.32元，买入金额12744000元，完成建仓。2011年11月23日临近收盘期间(14:56:24至14:59:28) ，任某某为了在短期内拉升股价，大量申报买入“X”4笔共计63000股，占尾市阶段市场申买量的比例高达75.54%；委托价格由29.60元升至32.00元，每笔均高于当时市场上的买1档价格，三分钟内将股价由29.35元拉升至30元收盘，拉升幅度达2.21%。2011年11月24日， 在达到操纵股价目的后，任某某将持有的50万股“X”全部卖出，导致该日股价震荡下跌。任某某通过尾市三分钟的操纵赚取近30万元。</p>",
            "<p><span style=' color: #ba0014;font-weight: 600;'>其实，正常投资者出于看好某只股票的投资价值，即使是在尾市期间买入，仍然属于合法行为。任某某行为的违法性在于其大量买入股票是为了拉高收盘价，诱骗投资者跟风，一旦目标得逞马上趁机套现，根本不是真实的交易目的。</span>这样的行为就违反了《证券法》第七十七条禁止以其他手段操纵证券市场的规定，构成《证券法》第二百零三条操纵市场的情形，必定会受到监管部门的严惩。<span style=' color: #ba0014;font-weight: 600;'>2011年至2014年期间，证监会先后两次对其作出处罚，开出3亿多元罚单。</span>  </p>",
            "<p>投资者进行市场投资时，应遵从符合价值规律的理性投资方式，结合市场、行业和公司的情况进行冷静分析，警惕市场操纵者兴风作浪，制造虚假繁荣。如果盲目跟风炒作，极易被市场操纵者利用，造成惨重损失。以本案为例，假设投资者小明被尾市股价的迅速上涨所诱惑，以收盘价30元价格追涨买入，次日即亏损3%。在此提醒广大投资者，尾市期间莫名发生股价异动，此中恐有蹊跷，跟风炒作、追涨杀跌实乃刀口舔血，小心天上掉下来的“馅饼”变成市场操纵者的“陷阱”，成为市场操纵者的高位接盘侠。</p>",
          ],
          hrefs: "摘自：中国证券监督管理委员会",
          to: "http://www.csrc.gov.cn/csrc/c100211/c1452047/content.shtml",
        },
        {
          p1: [
            "<p>某券商营业部前员工A（持证券经纪人执业证书）私下与该营业部客户B签订合作理财协议，约定由其对客户账户内60万资金进行证券买卖操作，委托期限为12个月。合同期内，账户如产生超过20%盈利，其享有盈利部分的20%，若盈利不超过20%则盈利全部为客户所有；如亏损超过20%，客户有权终止该协议或让其免费为其服务直到盈利为止。后因账户亏损较严重，双方提前终止协议。投资者B某因为盲目相信从业人员A某的承诺，自身财产遭到了侵害。</p>",
            "<p><span style=' color: #ba0014;font-weight: 600;'>证券公司员工私下接受客户委托，擅自代理客户从事证券投资理财的行为属于违规行为</span>。A某擅自代理客户从事证券投资理财，并约定分享投资收益，其行为已经构成代客理财行为，违反《证券法》《证券经纪人管理暂行规定》《证券经纪人执业规范（试行）》及《证券从业人员执业行为准则》。</p>",
            "<p>依据《证券公司监督管理条例》第四十五条的规定，证券公司可以依照《证券法》和本条例的规定，从事接受客户的委托、使用客户资产进行投资的证券资产管理业务。投资所产生的收益由客户享有，损失由客户承担，证券公司可以按照约定收取管理费用。证券公司从事证券资产管理业务，应当与客户签订证券资产管理合同，约定投资范围、投资比例、管理期限及管理费用等事项。证券资产管理业务属于公司行为，以证券公司为主体与投资者书面签署相关资产管理合同。</p>",
            "<p>而从业人员代客理财属于从业人员个人行为，一般是从业人员与投资者私下签署相关合同或口头约定相关内容。目前证券公司严禁从业人员从事违规代客理财活动，采取了一系列严密防范措施，并在对投资者进行电话回访过程中进行了充分的风险揭示。在这样的情况下，如果投资者仍然私下委托从业人员为其理财，则一般认定为从业人员的个人行为，投资者一旦因违规代客理财产生亏损，投资者只能向从业人员主张权利。</p>",
          ],
          hrefs: "摘自：中国证券监督管理委员会",
          to: "http://www.csrc.gov.cn/csrc/c100211/c1452037/content.shtml",
        },
      ],
    };
  },
  methods: {
    changebar(index) {
      this.actives = index;
    },
    to_waibu(a) {
      window.open(a);
    },
    to_index() {
      this.$router.push("/");
    },
  },
};
</script>
<style lang="less" scoped>
.card {
  width: 142px;
  height: 341px;
  background: url(../assets/img/banner1/card.png);
  position: fixed;
  right: 30px;
  top: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;
  .lis1 {
    padding-top: 24px;
    text-align: center;
    line-height: 24px;
    .text {
      width: 109px;
      height: 24px;
      background-color: #fff;
      font-size: 16px;
      font-weight: 600;
      color: #db1116;
      cursor: pointer;
    }
  }
  .lis2 {
    margin-top: 9px;
    width: 108px;
    height: 43px;
    border: 1px solid #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
  }
}
.h1 {
  width: 100%;
  height: 920px;
  background: url(../assets/img/banner1/h1.png);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  // align-items: flex-end;
  justify-content: flex-end;
  .h1-1 {
    width: 100%;
    height: 82px;
    background: url(../assets/img/banner1/h1-1.png);
    background-size: 100% 100%;
    .w {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .li-1 {
        cursor: pointer;
        width: 240px;
        height: 61px;
        background: url(../assets/img/banner1/h1-2.png);
        background-size: 100% 100%;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ba0014;
        line-height: 61px;
        margin-right: 15px;
        .text {
          padding-left: 20px;
        }
      }
      .li-2 {
        cursor: pointer;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }
      .li-3 {
        width: 1px;
        height: 32px;
        background: #ffffff;
        margin: 0 32px;
      }
    }
  }
}
.h2 {
  width: 100%;
  height: 1172px;
  background: url(../assets/img/banner1/h2.png);
  background-size: 100% 100%;
  .w {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 37px;
    }
    .li-2 {
      margin-top: 29px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #959494;
      line-height: 28px;
    }
    .li-3 {
      margin-top: 58px;
      width: 100%;
      display: flex;
      align-items: center;
      .text {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2a2a2a;
        margin-left: 17px;
      }
    }

    .li-4 {
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      margin-top: 20px;
      margin-bottom: 22px;
      width: 1200px;
      height: 716px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #4e4e4e;
      line-height: 25px;
      .boxx {
        width: 1112px;
        margin: 0 auto;
      }
    }
  }
}
.h3 {
  width: 100%;
  height: 1444px;
  background: url(../assets/img/banner1/h3.png);
  background-size: 100% 100%;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .li-1 {
      padding-top: 30px;
      width: 100%;
      display: flex;
      align-items: center;
      .text {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2a2a2a;
        margin-left: 17px;
      }
    }
    .li-2 {
      width: 1200px;
      height: 1222px;
      background-color: #fff;
      margin-top: 37px;
      display: flex;
      align-items: center;
      .p1,
      .p2,
      .p3 {
        font-size: 13px;
        color: #7a7a7a;
        width: 490px;
        font-family: Microsoft YaHei;
        line-height: 20px;
      }
      span {
        color: #d51014;
        font-weight: bold;
      }

      .left {
        width: 600px;
        height: 100%;

        display: flex;
        flex-direction: column;
        align-items: center;

        .www {
          padding-top: 45px;
        }
        .lis1 {
          width: 553px;
          height: 191px;
          background: url(../assets/img/banner1/h3-1.png);
          background-size: 100% 100%;
          margin-bottom: 25px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .p1 {
            padding-top: 50px;
            margin-bottom: 20px;
          }
        }
        .lis2 {
          width: 553px;
          height: 146px;
          background: url(../assets/img/banner1/h3-2.png);
          background-size: 100% 100%;
          margin-bottom: 30px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .lis3 {
          width: 553px;
          height: 133px;
          background: url(../assets/img/banner1/h3-3.png);
          background-size: 100% 100%;
          margin-bottom: 37px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .p1 {
            padding-top: 52px;
          }
        }
        .lis4 {
          width: 553px;
          height: 191px;
          background: url(../assets/img/banner1/h3-4.png);
          background-size: 100% 100%;
          margin-bottom: 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .p1 {
            padding-top: 44px;
          }
        }
        .lis5 {
          width: 553px;
          height: 136px;
          background: url(../assets/img/banner1/h3-5.png);
          background-size: 100% 100%;
          margin-bottom: 46px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .lis6 {
          width: 553px;
          height: 175px;
          background: url(../assets/img/banner1/h3-6.png);
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
      .right {
        width: 600px;

        display: flex;
        flex-direction: column;
        align-items: center;
        .wwww {
          padding-top: 0px;
        }
        .lis1 {
          width: 553px;
          height: 191px;
          background: url(../assets/img/banner1/h3-7.png);
          background-size: 100% 100%;
          margin-bottom: 28px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .p1 {
            padding-top: 31px;
            margin-bottom: 15px;
          }
        }
        .lis2 {
          width: 553px;
          height: 192px;
          background: url(../assets/img/banner1/h3-8.png);
          background-size: 100% 100%;
          margin-bottom: 33px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .p1 {
            margin-bottom: 15px;
          }
        }
        .lis3 {
          width: 553px;
          height: 132px;
          background: url(../assets/img/banner1/h3-9.png);
          background-size: 100% 100%;
          margin-bottom: 43px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .lis4 {
          width: 553px;
          height: 132px;
          background: url(../assets/img/banner1/h3-10.png);
          background-size: 100% 100%;
          margin-bottom: 27px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .lis5 {
          width: 553px;
          height: 136px;
          background: url(../assets/img/banner1/h3-11.png);
          background-size: 100% 100%;
          margin-bottom: 54px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .lis6 {
          width: 547px;
          height: 169px;
          background: url(../assets/img/banner1/h3-12.png);
          background-size: 100% 100%;
        }
      }
    }
    .li-3 {
      margin-top: 42px;
      width: 1200px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.h4 {
  width: 100%;
  height: 981px;
  background: url(../assets/img/banner1/h4.png);
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .w {
    width: 1200px;
    height: 925px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .boxx {
      width: 1135px;
      height: 48px;
    }
    .li-1 {
      width: 1135px;
      height: 123px;

      margin-bottom: 35px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .text {
        width: 1048px;

        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #636363;
        line-height: 25px;
      }
    }
    .li-6 {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #b6b6b6;
      margin-top: 38px;
    }
  }
}
.h5 {
  width: 100%;
  height: 1184px;
  background: url(../assets/img/banner1/h5.png);
  background-size: 100% 100%;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 14px;
      margin-bottom: 41px;
    }
    .li-2,
    .li-3 {
      width: 1200px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #959494;
      line-height: 28px;
    }
    .li-3 {
      margin-bottom: 30px;
    }
    .li-4 {
      margin-top: 58px;
      width: 100%;
      display: flex;
      align-items: center;
      .text {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2a2a2a;
        margin-left: 17px;
      }
    }
    .li-5 {
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      margin-top: 20px;
      margin-bottom: 22px;
      width: 1200px;
      height: 716px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #4e4e4e;
      line-height: 25px;
      .boxx {
        width: 1112px;
        margin: 0 auto;
      }
    }
  }
}
.h6 {
  width: 100%;
  height: 839px;
  background: url(../assets/img/banner1/h6.png);
  background-size: 100% 100%;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .li-1 {
      padding-top: 33px;
    }
    .li-2 {
      width: 1200px;
      height: 627px;
      background: url(../assets/img/banner1/h6-1.png);
      background-size: 100% 100%;
      margin-top: 56px;
      display: flex;
      flex-direction: column;
      .lis1 {
        width: 100%;
        height: 102px;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn1:last-child {
          border-right: 0;
        }
        .btn1 {
          width: 300px;
          height: 102px;
          color: #f4f4f4;
          font-size: 35px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          text-align: center;
          border-right: 1px solid #fff;
          .text {
            width: 100%;
            padding-top: 24px;
          }
        }
        .btn2 {
          width: 300px;
          font-size: 35px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          text-align: center;
          height: 102px;
          color: #ffd61d;
          background: url(../assets/img/banner1/h6-2.png);
          background-size: 100% 100%;
          .text {
            width: 100%;
            padding-top: 24px;
          }
        }
      }
      .lis2 {
        width: 100%;
        height: 525px;
        width: 1078px;
        margin: 0 auto;
        height: 100%;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #898989;

        position: relative;
        p {
          line-height: 20px;
          font-size: 18px;
          line-height: 1.4;
        }
      }

      .hrefs {
        position: absolute;
        right: 20px;
        bottom: 30px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/banner1.vue